import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n";
import { Mail, Copy } from "lucide-react";
import { toast } from "sonner";

const EMAIL = "wigfounder@gmail.com";

export default function Contattaci() {
  const { t } = useLang();
  return (
    <main className="pt-32 pb-28" data-testid="contattaci-page">
      <section className="max-w-3xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="hud-label mb-3" data-testid="contattaci-over">{t("cont.over")}</p>
          <h1 className="font-display text-5xl md:text-6xl uppercase mb-4" data-testid="contattaci-title">{t("cont.title")}</h1>
          <p className="text-steel leading-relaxed mb-10">{t("cont.sub")}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="chamfer border border-[#1A1A1A] bg-[#050505] p-7 md:p-9" data-testid="contattaci-post">
            <p className="hud-label mb-4">{t("cont.post_title")}</p>
            <p className="text-sm text-steel leading-relaxed mb-8">{t("cont.body")}</p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={`mailto:${EMAIL}?subject=Contatto%20WARDOGS.HQ&body=Ciao!%20Vi%20scrivo%20per%3A%0A`}
                className="chamfer-sm bg-wardogs hover:bg-wardogs-hover text-[#050505] font-mono text-xs uppercase tracking-[0.2em] font-bold px-8 py-4 transition-colors duration-300 flex items-center justify-center gap-3"
                data-testid="contattaci-mail-button"
              >
                <Mail className="w-4 h-4" /> {t("cont.mail_btn")}
              </a>
              <button
                onClick={() => { navigator.clipboard.writeText(EMAIL).then(() => toast.success(t("cont.copied"))).catch(() => {}); }}
                className="chamfer-sm border border-[#2A2A2A] hover:border-wardogs text-steel hover:text-white font-mono text-xs px-6 py-4 transition-colors duration-300 flex items-center justify-center gap-2"
                data-testid="contattaci-copy-email"
              >
                <Copy className="w-3.5 h-3.5" /> {EMAIL}
              </button>
            </div>
            <p className="font-mono text-[11px] text-[#4A4D51] mt-6">{t("cont.copy_hint")}</p>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
